var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"params"},_vm._l((_vm.params),function(param,key){return _c('div',{key:key},[_c('div',[_c('p',[_vm._v(_vm._s(key)+":")]),(typeof(param) === 'string' && param.indexOf('{') > -1 )?_c('pre',[_vm._v(_vm._s(JSON.parse(param)))]):_c('pre',[_vm._v(_vm._s(param))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }